import styled from '@emotion/styled';

import videoPosterUrl from '@assets/img/intro-video-poster.png';
import { ButtonPlay, ButtonVolume } from '@features/Button';
import { ifProp } from '@lib/ifProp';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';
import { visuallyHidden } from '@styles/mixins/visuallyHidden';

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;

  ${getMediaqueryStyled('md')} {
    min-height: auto;
    padding-top: 140px;
  }
`;

export const Lead = styled.p`
  ${visuallyHidden}
`;

export const Title = styled.h1`
  ${visuallyHidden}
`;

export const Video = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  min-height: 1080px;
  transform: translateX(-50%) translateY(-50%);
  object-fit: cover;
  background-image: ${videoPosterUrl};

  ${getMediaqueryStyled('xl')} {
    min-height: 900px;
  }

  ${getMediaqueryStyled('lg')} {
    min-height: 562px;
  }

  ${getMediaqueryStyled('md')} {
    top: auto;
    left: auto;
    position: relative;
    width: 100%;
    height: auto;
    min-height: auto;
    object-fit: contain;
    transform: none;
  }
`;

export const StyledButtonVolume = styled(ButtonVolume)`
  position: absolute;
  right: 90px;
  bottom: 90px;

  ${getMediaqueryStyled('xl')} {
    right: 80px;
    bottom: 80px;
  }

  ${getMediaqueryStyled('lg')} {
    right: 45px;
    bottom: 45px;
  }
`;

const CENTER_IT = 'translate(-50%, 50%)';

export const StyledButtonPlay = styled(ButtonPlay)`
  position: absolute;
  z-index: 10;
  left: 50%;
  bottom: 35%;
  transform: ${ifProp('isVisible', `${CENTER_IT} scale(1)`, `${CENTER_IT} scale(0)`)};
`;
